/**
 * Event bus for decoupling side effects from core flows (Medusa pattern).
 * Subscribers register for events and run independently — a failed subscriber
 * never blocks other subscribers or the emitting flow.
 */

const listeners = new Map();

export function on(event, handler) {
  if (!listeners.has(event)) listeners.set(event, []);
  listeners.get(event).push(handler);
  return () => off(event, handler);
}

export function off(event, handler) {
  const handlers = listeners.get(event);
  if (!handlers) return;
  const idx = handlers.indexOf(handler);
  if (idx !== -1) handlers.splice(idx, 1);
}

export async function emit(event, payload) {
  const handlers = listeners.get(event) || [];
  const results = [];

  for (const handler of handlers) {
    try {
      await handler(payload);
      results.push({ handler: handler._name || handler.name || "anonymous", ok: true });
    } catch (err) {
      results.push({ handler: handler._name || handler.name || "anonymous", ok: false, error: err.message });
    }
  }

  return results;
}

export function clear() {
  listeners.clear();
}

export function listenerCount(event) {
  return (listeners.get(event) || []).length;
}

// Event names
export const EVENTS = {
  ORDER_PLACED: "order.placed",
  ORDER_CANCELLED: "order.cancelled",
  ORDER_STATUS_CHANGED: "order.status_changed",
  STORE_CREDIT_APPLIED: "store_credit.applied",
};
